<template>

  <div class="buddy-avatar healthyBuddy" :class="'buddy-id-'+buddy.id" v-show="!loadingBuddy">
    <div class="head" v-html="svgs['head']"></div>
    <div class="hat" v-html="svgs['hat']"></div>
    <div class="eyes" v-html="svgs['eyes']"></div>
    <div class="ear_left" v-html="svgs['ear_left']"></div>
    <div class="ear_right" v-html="svgs['ear_right']"></div>
    <div class="snout" v-html="svgs['snout']"></div>
    <div class="head_fuzz" v-html="svgs['head_fuzz']"></div>
    <div class="head_wrinkles" v-html="svgs['head_wrinkles']"></div>
    <div class="middle" v-html="svgs['middle']"></div>
    <div class="shirt" v-html="svgs['shirt']"></div>
    <div class="nose" v-html="svgs['nose']"></div>
    <div class="mouth" v-html="svgs['mouth']"></div>
    <div class="arm_left" v-html="svgs['arm_left']"></div>
    <div class="arm_right" v-html="svgs['arm_right']"></div>
    <div class="hand" v-html="svgs['hand']"></div>
    <div class="antenna" v-html="svgs['antenna']"></div>
    <div class="eyebrow_left" v-html="svgs['eyebrow_left']"></div>
    <div class="eyebrow_right" v-html="svgs['eyebrow_right']"></div>
    <div class="leg_left" v-html="svgs['leg_left']"></div>
    <div class="leg_right" v-html="svgs['leg_right']"></div>
    <div class="pants" v-html="svgs['pants']"></div>
    <div class="shoe_left" v-html="svgs['shoe_left']"></div>
    <div class="shoe_right" v-html="svgs['shoe_right']"></div>
    <div class="sleeve_left" v-html="svgs['sleeve_left']"></div>
    <div class="sleeve_right" v-html="svgs['sleeve_right']"></div>

  </div>

  <div class="loading-icon" v-show="loadingBuddy">
    <LoadIcon :show="true"></LoadIcon>
  </div>

</template>

<script>
import BodyPartLibrary from "@/mixins/BodyPartLibrary";
import LoadIcon from "@/components/StudentPlatform/LoadIcon";
import tinyColor from "tinycolor2";
import AccessoryLibrary from "@/mixins/AccessoryLibrary.js";

export default {
  name: "DiplomaBuddy",
  components: { LoadIcon },
  mixins: [ BodyPartLibrary ],
  props: {
    buddy: Object,
  },
  computed: {},
  watch: {
    buddy: {
      handler()
      {
        if (this.showBuddy && this.windowData.width !== undefined && this.buddyData.bodyPartIds !== undefined && this.buddyData.bodyPartIds['head'] !== '')
        {
          this.setUpBuddy();
        }
      },
      deep: true,
    },
  },
  data()
  {
    return {
      buddyData: {
        name: null,
        id: null,
        fitness: {
          posture: 0,
          colorVibrancy: 0,
          animation: 0,
        },
        avatar: null,
        buddyConfig: {
          className: '',
          school: {
            id: null,
            name: '',
            postalCode: '',
          },
          schoolYear: {
            endDate: null,
            startDate: null,
          },
          studentCount: null,
        },
        expNextLevel: null,
        experience: null,
        level: null,
        bodyPartIds: {
          head: { name: 'head', id: "" },
          head_fuzz: { name: 'head_fuzz', id: "" },
          head_wrinkles: { name: 'head_wrinkles', id: "" },
          body_wrinkles: { name: 'body_wrinkles', id: "" },
          eyes: { name: 'eyes-01', id: "" },
          antenna: { name: 'antenna-01', id: "" },
          snout: { name: 'snout', id: "" },
          whiskers: { name: 'whiskers-05', id: "" },
          nose: { name: 'nose-01', id: "" },
          mouth: { name: 'mouth-01', id: "" },
          middle: { name: 'body', id: "" },
          ear_left: { name: 'ears-01', id: "" },
          ear_right: { name: 'ears-01', id: "" },
          arm_left: { name: 'arm', id: "" },
          arm_right: { name: 'arm', id: "" },
          leg_left: { name: 'leg', id: "" },
          leg_right: { name: 'leg', id: "" },
          eyebrow_left: { name: 'eyebrow', id: "" },
          eyebrow_right: { name: 'eyebrow', id: "" },
          tail: {name: 'tail', id: ""},
        },
        accessoryIds: {
          hat: { name: '', id: "" },
          shirt: { name: '', id: "" },
          sleeve_left: { name: '', id: "" },
          sleeve_right: { name: '', id: "" },
          shoe_left: { name: '', id: "" },
          shoe_right: { name: '', id: "" },
          hand: { name: '', id: "" },
          pants: { name: '', id: "" },
        },
        colors: {
          buddy_primary: '',
          buddy_secondary: '',
          buddy_tertiary: '',
          accessory_primary: '',
          accessory_secondary: '',
          accessory_tertiary: '',
        }
      },
      svgs: {},
      loadingBuddy: false,
      showMaxHealthy: true,
    }
  },
  methods: {

    //TODO (lm): clean up, should eventually just use the data provided
    applyBuddyData(data)
    {
      let bodyPartIds = {
        'antennas': 'antenna',
        'eyes': 'eyes',
        'mouth': 'mouth',
        'nose': 'nose',
        'ears': 'ear_left',
        'markings': 'whiskers',
      }

      let accessoryIds = {
        accessory: "hand",
        head: "hat",
        legs: "pants",
        chest: "shirt",
        feet: "shoe_left",
      }

      for (const [ key, value ] of Object.entries(data))
      {
        if (value !== undefined)
        {
          if (key === 'body')
          {
            for (const [ key, value ] of Object.entries(data.body))
            {
              if (value !== undefined)
              {
                this.buddyData.bodyPartIds[bodyPartIds[key]] = value;

              }
            }
          }
          else if (key === 'outfit')
          {
            for (const [ key, value ] of Object.entries(data.outfit))
            {
              if (value !== undefined)
              {
                this.buddyData.accessoryIds[accessoryIds[key]] = value;

              }
            }
          }
          else
          {
            if (this.buddyData[key] !== undefined)
            {
              this.buddyData[key] = value;
            }
          }
        }
      }

      if (data.body.skinColor !== undefined)
      {
        this.buddyData.colors.buddy_primary = data.body.skinColor.primary;
        this.buddyData.colors.buddy_secondary = data.body.skinColor.secondary;
        this.buddyData.colors.buddy_tertiary = data.body.skinColor.tertiary;
      }


      if (data.outfit.colors !== undefined)
      {
        this.buddyData.colors.accessory_primary = data.outfit.colors.primary !== "" ? data.outfit.colors.primary : "rgb(155,171,209)";
        this.buddyData.colors.accessory_secondary = data.outfit.colors.secondary !== "" ? data.outfit.colors.secondary : "rgb(239,209,25)";
        this.buddyData.colors.accessory_tertiary = data.outfit.colors.tertiary !== "" ? data.outfit.colors.tertiary : "rgb(243,238,238)";
      }
      else
      {
        this.buddyData.colors.accessory_primary = "rgb(155,171,209)";
        this.buddyData.colors.accessory_secondary = "rgb(239,209,25)";
        this.buddyData.colors.accessory_tertiary = "rgb(243,238,238)";
      }

      this.buddyData.bodyPartIds.ear_right = this.buddyData.bodyPartIds.ear_left;
    },

    async renderBuddy()
    {
      this.loadingBuddy = true;

      let head = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["head"].name, this.buddy.buddyConfig.grade);
      this.svgs["head"] = head.svg.outerHTML;

      if (this.buddy.accessoryIds["hat"].id)
      {
        let hat = await AccessoryLibrary.getAccessoryFromFile(this.buddy.accessoryIds["hat"].name, this.buddy.buddyConfig.grade);
        this.svgs["hat"] = hat.svg.outerHTML;
      }

      let eyes = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["eyes"].name, this.buddy.buddyConfig.grade);
      this.svgs["eyes"] = eyes.svg.outerHTML;

      let ear_left = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["ear_left"].name, this.buddy.buddyConfig.grade);
      this.svgs["ear_left"] = ear_left.svg.outerHTML;

      let ear_right = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["ear_right"].name, this.buddy.buddyConfig.grade);
      this.svgs["ear_right"] = ear_right.svg.outerHTML;

      let snout = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["snout"].name, this.buddy.buddyConfig.grade);
      this.svgs["snout"] = snout.svg.outerHTML;

      let middle = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["middle"].name, this.buddy.buddyConfig.grade);
      this.svgs["middle"] = middle.svg.outerHTML;

      if (this.buddy.accessoryIds["shirt"].id)
      {
        let shirt = await AccessoryLibrary.getAccessoryFromFile(this.buddy.accessoryIds["shirt"].name, this.buddy.buddyConfig.grade);
        this.svgs["shirt"] = shirt.svg.outerHTML;
      }

      if (this.buddy.accessoryIds["pants"].id)
      {
        let pants = await AccessoryLibrary.getAccessoryFromFile(this.buddy.accessoryIds["pants"].name, this.buddy.buddyConfig.grade);
        this.svgs["pants"] = pants.svg.outerHTML;
      }

      let nose = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["nose"].name, this.buddy.buddyConfig.grade);
      this.svgs["nose"] = nose.svg.outerHTML;

      let mouth = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["mouth"].name, this.buddy.buddyConfig.grade);
      this.svgs["mouth"] = mouth.svg.outerHTML;

      let arm_left = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["arm_left"].name, this.buddy.buddyConfig.grade);
      this.svgs["arm_left"] = arm_left.svg.outerHTML;

      if (this.buddy.accessoryIds["sleeve_left"].id)
      {
        let sleeve = await AccessoryLibrary.getAccessoryFromFile(this.buddy.accessoryIds["sleeve_left"].name, this.buddy.buddyConfig.grade);
        this.svgs["sleeve_left"] = sleeve.svg.outerHTML;
      }

      if (this.buddy.accessoryIds["hand"].id)
      {
        let hand = await AccessoryLibrary.getAccessoryFromFile(this.buddy.accessoryIds["hand"].name, this.buddy.buddyConfig.grade);
        this.svgs["hand"] = hand.svg.outerHTML;
      }


      let arm_right = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["arm_right"].name, this.buddy.buddyConfig.grade);
      this.svgs["arm_right"] = arm_right.svg.outerHTML;

      if (this.buddy.accessoryIds["sleeve_right"].id)
      {
        let sleeve = await AccessoryLibrary.getAccessoryFromFile(this.buddy.accessoryIds["sleeve_right"].name, this.buddy.buddyConfig.grade);
        this.svgs["sleeve_right"] = sleeve.svg.outerHTML;
      }

      let antenna = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["antenna"].name, this.buddy.buddyConfig.grade);
      this.svgs["antenna"] = antenna.svg.outerHTML;

      let eyebrow_left = await BodyPartLibrary.getBodyPartFromFile(this.buddyData.bodyPartIds["eyebrow_left"].name, this.buddy.buddyConfig.grade);
      if (eyebrow_left.svg !== null) {
        this.svgs["eyebrow_left"] = eyebrow_left.svg.outerHTML;
      }

      let eyebrow_right = await BodyPartLibrary.getBodyPartFromFile(this.buddyData.bodyPartIds["eyebrow_right"].name, this.buddy.buddyConfig.grade);
      if (eyebrow_right.svg !== null) {
        this.svgs["eyebrow_right"] = eyebrow_right.svg.outerHTML;
      }

      let leg_left = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["leg_left"].name, this.buddy.buddyConfig.grade);
      this.svgs["leg_left"] = leg_left.svg.outerHTML;

      if (this.buddy.accessoryIds["shoe_left"].id)
      {
        let shoe_left = await AccessoryLibrary.getAccessoryFromFile(this.buddy.accessoryIds["shoe_left"].name, this.buddy.buddyConfig.grade);
        this.svgs["shoe_left"] = shoe_left.svg.outerHTML;
      }

      let leg_right = await BodyPartLibrary.getBodyPartFromFile(this.buddy.bodyPartIds["leg_right"].name, this.buddy.buddyConfig.grade);
      this.svgs["leg_right"] = leg_right.svg.outerHTML;

      if (this.buddy.accessoryIds["shoe_right"].id)
      {
        let shoe_right = await AccessoryLibrary.getAccessoryFromFile(this.buddy.accessoryIds["shoe_right"].name, this.buddy.buddyConfig.grade);
        this.svgs["shoe_right"] = shoe_right.svg.outerHTML;
      }

      //Make sure the body parts have been rendered before applying colors by waiting one tick.
      await this.$nextTick(function()
      {
        this.applyColors();
      });

      this.loadingBuddy = false;
    },

    applyColors()
    {

      let alteredColors = {};

      for (const [ key, value ] of Object.entries(this.buddy.colors))
      {
        if (this.buddy.fitness.colorVibrancy === "moderate")
        {
          alteredColors[key] = tinyColor(value).lighten(10).toString();
        }
        else if (this.buddy.fitness.colorVibrancy === "low")
        {
          alteredColors[key] = tinyColor(value).lighten(20).toString();
        }
        else
        {
          alteredColors[key] = value;
        }
      }

      let buddyEl = document.querySelector(".healthyBuddy");
      console.log(buddyEl)

      if (!this.showMaxHealthy)
      {
        buddyEl.querySelectorAll('.bb_colour-0' + (1)).forEach(el =>
        {
          el.style.fill = alteredColors['buddy_primary'];
          console.log("filling with" + alteredColors['buddy_primary'])
        });
      }
      else
      {
        buddyEl.querySelectorAll('.bb_colour-0' + (1)).forEach(el =>
        {
          el.style.fill = this.buddy.colors['buddy_primary'];
        });
      }

      buddyEl.querySelectorAll('.bb_colour-0' + (2)).forEach(el =>
      {
        el.style.fill = this.buddy.colors['buddy_secondary'];
      });

      buddyEl.querySelectorAll('.bb_colour-0' + (3)).forEach(el =>
      {
        el.style.fill = this.buddy.colors['buddy_tertiary'];
      });

      buddyEl.querySelectorAll('.accessory_color' + (1)).forEach(el =>
      {
        el.style.fill = this.buddy.colors.accessory_primary;
      });

      buddyEl.querySelectorAll('.accessory_color' + (2)).forEach(el =>
      {
        el.style.fill = this.buddy.colors.accessory_secondary;
      });

      buddyEl.querySelectorAll('.accessory_color' + (3)).forEach(el =>
      {
        el.style.fill = this.buddy.colors.accessory_tertiary;
      });
    },

    setUpBuddy()
    {
      this.renderBuddy();
      this.applyColors();
    },
  },
  async mounted()
  {
    //await this.fetchBuddy();
    this.setUpBuddy();
  }
}
</script>

<style lang="scss" scoped>

.loading-icon {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #F3F8FD;
}

.buddy-avatar {
  position: absolute;
  width: 50%;
  height: 50%;
  transform: scale(2);
  //opacity: 0.5;
  //overflow: hidden;
  pointer-events: none;
  bottom: 100px;
  left: 50px;
}

.head ::v-deep, .eyes ::v-deep, .snout ::v-deep, .nose ::v-deep, .mouth ::v-deep, .antenna ::v-deep, .head_wrinkles ::v-deep,

,
.head_fuzz ::v-deep {
  svg {
    width: 140px;
    height: 170px;
    position: absolute;
    top: -30px;
    z-index: 2;
    left: -22px;
  }
}

.hat ::v-deep {
  svg {
    width: 140px;
    height: 170px;
    position: absolute;
    top: -30px;
    z-index: 2;
    left: -22px;
  }
}

.middle ::v-deep {
  svg {
    width: 138px;
    height: 134px;
    position: absolute;
    top: 89px;
    left: -19px;
    z-index: 1;
  }
}

.shirt ::v-deep {
  svg {
    width: 138px;
    height: 134px;
    position: absolute;
    top: 89px;
    left: -19px;
    z-index: 1;
  }
}

.pants ::v-deep {
  svg {
    width: 138px;
    height: 134px;
    position: absolute;
    top: 89px;
    left: -19px;
    z-index: 1;
  }
}


.ear_left ::v-deep {
  svg {
    width: 52px;
    height: 100px;
    position: absolute;
    top: 24px;
    left: -40px;
    z-index: 1;
    transform: scale(-1, 1);
  }
}

.ear_right ::v-deep {
  svg {
    width: 52px;
    height: 100px;
    position: absolute;
    top: 22px;
    left: 85px;
    z-index: 1;
    transform: rotate(11deg);
  }
}

.arm_left ::v-deep, .sleeve_left ::v-deep {
  svg {
    transform: scale(-1, 1);
    width: 56px;
    height: 98px;
    position: absolute;
    top: 100px;
    left: -6px;
    z-index: 1;
  }
}

.hand ::v-deep {
  svg {
    transform: scale(-2, 2);
    width: 56px;
    height: 98px;
    position: absolute;
    top: 100px;
    left: -6px;
    z-index: 3;
  }
}

.arm_right ::v-deep, .sleeve_right ::v-deep {
  svg {
    width: 55px;
    height: 98px;
    position: absolute;
    top: 65px;
    left: 65px;
    z-index: 5;
    transform: scale(-1, 1) rotate(160deg);
  }
}

.eyebrow_left ::v-deep {
  svg {
    width: 24px;
    height: 41px;
    position: absolute;
    top: 31px;
    left: 12px;
    transform: scale(-1, 1);
    z-index: 2;
  }
}

.eyebrow_right ::v-deep {
  svg {
    width: 24px;
    height: 41px;
    position: absolute;
    top: 31px;
    left: 59px;
    transform: rotate(-6deg);
    z-index: 2;
  }
}


.leg_left ::v-deep {
  svg {
    transform: rotate(0deg) scale(-1, 1);
    width: 95px;
    height: 102px;
    position: absolute;
    top: 143px;
    left: -36px;
    z-index: 0;
  }
}

.shoe_left ::v-deep {
  svg {
    transform: rotate(0deg) scale(-1, 1);
    width: 95px;
    height: 102px;
    position: absolute;
    top: 143px;
    left: -36px;
    z-index: 0;
  }
}

.leg_right ::v-deep {
  svg {
    transform: rotate(0deg);
    width: 95px;
    height: 102px;
    position: absolute;
    top: 144px;
    left: 41px;
    z-index: 0;
  }
}

.shoe_right ::v-deep {
  svg {
    transform: rotate(0deg);
    width: 95px;
    height: 102px;
    position: absolute;
    top: 144px;
    left: 41px;
    z-index: 0;
  }
}

.white-bg {
  background-color: white;
  width: 250px;
  height: 200px;
  position: absolute;
  left: -100px;
  top: 0px;
}


</style>